function createResponsive(fn) {
  return prop => Array.isArray(prop) ? prop.map(fn) : fn(prop);
}

export { createResponsive as default };
